document.addEventListener("click", function (e) {
  if (e.target && e.target.className == "swatch-link") {
    e.preventDefault();

    const img1 = e.target.closest(".grid__item").querySelector(".media img:first-child");
    const img2 = e.target.closest(".grid__item").querySelector(".media img:last-child");

    img1.setAttribute("src", e.target.parentNode.dataset.image);
    img1.setAttribute("srcset", e.target.parentNode.dataset.image);

    img2.setAttribute("src", e.target.parentNode.dataset.altImage);
    img2.setAttribute("srcset", e.target.parentNode.dataset.altImage);

    e.target.closest(".grid__item").querySelector(".other-variants .selected").classList.remove("selected");
    e.target.parentNode.classList.add("selected");
  }
});

// Related Products Slider
function initRelatedProductsSlider() {
  const slider = document.getElementById("relatedProductsSlider");
  if (!slider) return;

  const prevButton = document.getElementById("prevButton");
  const nextButton = document.getElementById("nextButton");
  const slides = slider.querySelectorAll(".custom-related-products__slide");

  if (!slides.length) return;

  const slideWidth = slides[0].offsetWidth;
  const slidesPerView = window.innerWidth >= 750 ? 2 : 2;
  let currentIndex = 0;
  const isMobile = window.innerWidth < 750;

  function updateButtons() {
    prevButton.disabled = currentIndex === 0;

    if (slidesPerView > 1) {
      nextButton.disabled = currentIndex >= slides.length - slidesPerView;
    } else {
      nextButton.disabled = currentIndex >= slides.length - slidesPerView - 1;
    }
  }

  function scrollToSlide(index) {
    const scrollAmount = index * (slideWidth + (window.innerWidth >= 750 ? 32 : 24));
    slider.scrollTo({
      left: scrollAmount,
      behavior: "smooth",
    });
    currentIndex = index;
    updateButtons();
  }

  // Controls
  if (prevButton && nextButton) {
    prevButton.addEventListener("click", () => {
      scrollToSlide(Math.max(0, currentIndex - slidesPerView));
    });
    nextButton.addEventListener("click", () => {
      scrollToSlide(Math.min(slides.length - slidesPerView, currentIndex + slidesPerView));
    });
    // Op mobiel: verberg knoppen volledig (alleen swipe toegestaan)
  }

  // Update buttons on resize
  window.addEventListener("resize", () => {
    currentIndex = 0;
    scrollToSlide(0);
  });

  // Initial button state
  updateButtons();

  // Init swipe (en onderdruk native scroll/other interactions op mobiel)
  initSwipe(slider, {
    step: slidesPerView,
    suppressNative: true,
  });
}

// Initialize sliders when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  initRelatedProductsSlider();
  initFilterBubbleUpdate();
  initScrollAndClickFilterButton();
});

// Swipe handling
function initSwipe(slider, opts = {}) {
  let touchstartX = 0;
  let touchstartY = 0;
  let touchendX = 0;
  let touchendY = 0;
  const step = typeof opts.step === 'number' ? opts.step : 2;
  let intentDecided = false;
  let isHorizontalIntent = false;

  const prevBtn = slider.parentNode.querySelector('#prevButton');
  const nextBtn = slider.parentNode.querySelector('#nextButton');
  
  slider.addEventListener('touchstart', function(e) {
      touchstartX = e.touches[0]?.screenX;
      touchstartY = e.touches[0]?.screenY;
      intentDecided = false;
      isHorizontalIntent = false;
  }, { passive: true });
  
  // Onderdruk native scroll zodat uitlijning stabiel blijft
  if (opts.suppressNative) {
    slider.addEventListener('touchmove', function(e) {
      const x = e.touches[0]?.screenX;
      const y = e.touches[0]?.screenY;
      const dx = x - touchstartX;
      const dy = y - touchstartY;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      const intentThreshold = 8; // px om intent te bepalen
      if (!intentDecided) {
        if (absX > absY + intentThreshold) {
          intentDecided = true;
          isHorizontalIntent = true;
        } else if (absY > absX + intentThreshold) {
          intentDecided = true;
          isHorizontalIntent = false;
        }
      }
      // Alleen blokkeren als horizontale swipe-intent
      if (intentDecided && isHorizontalIntent) {
        e.preventDefault();
      }
    }, { passive: false });
  }
  
  slider.addEventListener('touchend', function(e) {
      touchendX = e.changedTouches[0]?.screenX;
      touchendY = e.changedTouches[0]?.screenY;
      handleSwipe();
  }, { passive: true }); 
  
  function handleSwipe() {
      const dx = touchendX - touchstartX;
      const dy = touchendY - touchstartY;
      const threshold = 30; // minimale swipe afstand
      // Als intent verticaal of niet beslist → niets doen zodat pagina kan scrollen
      if (!isHorizontalIntent) return;
      if (Math.abs(dx) < threshold) return; // te kleine swipe
      if (dx < 0 && nextBtn) {
        // naar links → volgende batch
        for (let i = 0; i < 1; i += 1) nextBtn.click();
      } else if (dx > 0 && prevBtn) {
        // naar rechts → vorige batch
        for (let i = 0; i < 1; i += 1) prevBtn.click();
      }
  }
}

function initScrollAndClickFilterButton() {
  const stickyContainer = document.getElementById('sticky-scroll-and-click-container');
  const stickyButton = document.getElementById('sticky-scroll-and-click-button');
  const mainFilterTrigger = document.querySelector('.filters-top-trigger');
  const mainFilterClickTarget = document.querySelector('.mobile-facets__wrapper summary');

  if (!stickyContainer || !stickyButton || !mainFilterTrigger || !mainFilterClickTarget) return;

  // Visibility logic
  const checkPosition = () => {
    const triggerRect = mainFilterTrigger.getBoundingClientRect();
    stickyContainer.classList.toggle('show', triggerRect.bottom < 0);
  };

  window.addEventListener('scroll', checkPosition, { passive: true });
  window.addEventListener('resize', checkPosition, { passive: true });
  checkPosition();

  // Click logic
  stickyButton.addEventListener('click', () => {
    // Scroll to the top of the main content instantly
    document.querySelector('main').scrollIntoView({ behavior: 'auto' });

    // Use requestAnimationFrame to ensure the click happens after the scroll is processed
    requestAnimationFrame(() => {
      mainFilterClickTarget.click();
    });
  });
}

// Renamed from initStickyFilterReveal
function initFilterBubbleUpdate() {
  // Bubble count rechtsboven op de sorteerknop
  const getActiveFiltersCount = () => {
    // Tel actief geselecteerde filterwaarden op de zichtbare (mobile/desktop) form
    const isMobile = window.innerWidth < 990;
    const form = isMobile
      ? document.getElementById('FacetFiltersFormMobile')
      : document.getElementById('FacetFiltersForm');
    if (!form) return 0;

    let count = 0;
    // checkbox/radio waarden
    count += form.querySelectorAll('.js-filter input[type="checkbox"]:checked, .js-filter input[type="radio"]:checked').length;
    // prijs-range (als een van de velden gevuld is telt het als 1)
    const priceWrappers = form.querySelectorAll('.facets__price');
    priceWrappers.forEach((wrap) => {
      const min = wrap.querySelector('input[name*="[min]"]');
      const max = wrap.querySelector('input[name*="[max]"]');
      if ((min && min.value) || (max && max.value)) count += 1;
    });
    return count;
  };

  const updateBubble = () => {
    const active = getActiveFiltersCount();
    // Select ALL bubble elements and update them
    document.querySelectorAll('[data-active-filters-count]').forEach((el) => {
      el.textContent = String(active);
      el.style.display = active > 0 ? 'flex' : 'none'; // Use flex for centering
    });

    // Facet-specifieke bubbles in uitklaplijst tonen per filtergroep
    // Loop door alle mobile filter-details en tel actieve waarden per groep
    document.querySelectorAll('.mobile-facets__details').forEach((details, idx) => {
      let groupCount = 0;
      groupCount += details.querySelectorAll('.js-filter input[type="checkbox"]:checked, .js-filter input[type="radio"]:checked').length;
      const priceWrap = details.querySelector('.facets__price');
      if (priceWrap) {
        const min = priceWrap.querySelector('input[name*="[min]"]');
        const max = priceWrap.querySelector('input[name*="[max]"]');
        if ((min && min.value) || (max && max.value)) groupCount += 1;
      }
      const bubble = details.querySelector('.filter-bubble--facet');
      if (!bubble) return;
      if (groupCount > 0) {
        bubble.textContent = String(groupCount);
        bubble.style.display = 'inline-block';
      } else {
        bubble.style.display = 'none';
      }
    });
  };

  updateBubble();
  window.addEventListener('resize', () => setTimeout(updateBubble, 50));
  document.addEventListener('change', (e) => {
    if (e.target.closest('.js-filter')) setTimeout(updateBubble, 50);
  });
  // Observe DOM updates binnen facet forms (ajax her-render)
  const moTargets = [document.getElementById('FacetFiltersFormMobile'), document.getElementById('FacetFiltersForm')].filter(Boolean);
  moTargets.forEach((target) => {
    const mo = new MutationObserver(() => setTimeout(updateBubble, 50));
    mo.observe(target, { childList: true, subtree: true });
  });
}
